export interface Testimonial {
  id: number;
  name: string;
  role: string;
  quote: string;
  logoUrl?: string;
  logoClass?: string;
}

export interface FaqItem {
  id: number;
  question: string;
  answer: string;
}

export interface PartnerLogo {
  id: number;
  name: string;
  image: string;
}

export interface PricingPlan {
  id: string;
  name: string;
  amount: string;
  customRate?: boolean;
  perText: string;
  description: string;
  concurrentExams: string;
  monthlyTotal: string;
  ctaText: string;
  includedFeatures: string[];
  excludedFeatures: string[];
}

export const LANDING_PARTNER_LOGOS: PartnerLogo[] = [
  { id: 1, name: 'Pondicherry University', image: 'assets/images/Logos/01_Pondicherry_University.png' },
  { id: 2, name: 'Don Bosco Tech', image: 'assets/images/Logos/02_Don_Bosco_Tech.png' },
  { id: 3, name: 'Sharda University', image: 'assets/images/Logos/03_Sharda_University.png' },
  { id: 4, name: 'FFSC', image: 'assets/images/Logos/04_FFSC.png' },
  { id: 5, name: 'NIELIT', image: 'assets/images/Logos/05_NIELIT.png' },
  { id: 6, name: 'HMCGSSC', image: 'assets/images/Logos/06_HMCGSSC.png' },
  { id: 7, name: 'ICICI Bank', image: 'assets/images/Logos/07_ICICI_Bank.png' },
  { id: 8, name: 'bigbasket', image: 'assets/images/Logos/08_bigbasket.png' },
  { id: 9, name: 'AU Foundation', image: 'assets/images/Logos/09_AU_Foundation.png' },
  { id: 10, name: 'Gold Emblem', image: 'assets/images/Logos/10_Gold_Emblem.png' },
  { id: 11, name: 'Sri Venkateshwara University', image: 'assets/images/Logos/11_Sri_Venkateshwara_University.png' },
  { id: 12, name: 'IIT Alumni India', image: 'assets/images/Logos/12_IIT_Alumni_India.png' },
  { id: 13, name: 'BWSSC', image: 'assets/images/Logos/13_BWSSC.png' },
  { id: 14, name: 'Construction Skill Development Council', image: 'assets/images/Logos/14_Construction_Skill_Development_Council.png' },
  { id: 15, name: 'ESSCI', image: 'assets/images/Logos/15_ESSCI.png' },
  { id: 16, name: 'Ambuja Foundation', image: 'assets/images/Logos/16_Ambuja_Foundation.png' },
  { id: 17, name: 'NIIT Foundation', image: 'assets/images/Logos/17_NIIT_Foundation.png' },
  { id: 18, name: 'SINGER', image: 'assets/images/Logos/18_SINGER.png' },
  { id: 19, name: 'Navriti', image: 'assets/images/Logos/19_Navriti_Logo.png' },
  { id: 20, name: 'IMS Ghaziabad', image: 'assets/images/Logos/20_IMS_Ghaziabad.png' },
  { id: 21, name: 'LearnET', image: 'assets/images/Logos/21_LearnET.png' },
  { id: 22, name: 'ASCI', image: 'assets/images/Logos/22_ASCI.png' },
  { id: 23, name: 'NSDC', image: 'assets/images/Logos/23_NSDC.png' },
  { id: 24, name: 'RASCI', image: 'assets/images/Logos/24_RASCI.png' },
  { id: 25, name: 'India Foundation', image: 'assets/images/Logos/25_India_Foundation.png' },
  { id: 26, name: 'Canara Bank', image: 'assets/images/Logos/26_Canara_Bank.png' },
  { id: 27, name: 'Tata STRIVE', image: 'assets/images/Logos/27_Tata_STRIVE.png' }
];

export const LANDING_TESTIMONIALS: Testimonial[] = [
  {
    id: 1,
    name: 'Nisha Singh',
    role: 'Sr. Manager Assessments',
    quote: '“Navriti completed assessments professionally, providing user-friendly platforms and support for each batch. Wishing the team great success and continued success ahead.”',
    logoUrl: 'assets/images/Logos/Testimonials/MEPSC.png'
  },
  {
    id: 2,
    name: 'Rambir Singh',
    role: 'IT Manager',
    quote: '“The assessment services provided by Navriti were good on all parameters with quality service. Their AI platforms are user friendly. I wish the Navriti team a very best of luck.”',
    logoUrl: 'assets/images/Logos/Testimonials/TSSC.png'
  },
  {
    id: 3,
    name: 'Ashish Srivastava',
    role: 'Additional Director',
    quote: '“Navriti Technologies meets high-volume competency assessments, ensuring quality benchmarks. Their coordination and timeliness make them a top partner.”',
    logoUrl: 'assets/images/Logos/Testimonials/MEPSC.png'
  },
  {
    id: 4,
    name: 'Manish Bhatnagar',
    role: 'Additional Director',
    quote: '“Navriti was supportive and efficient in completing two assessments. I appreciate their prompt, professional work and wish them continued success.”',
    logoUrl: 'assets/images/Logos/Testimonials/ips.png',
    logoClass: 'ips-logo'
  },
  {
    id: 5,
    name: 'Ankita',
    role: 'Assessment Department',
    quote: '“We partnered with Navriti this year and are very pleased with their quality services. Their team is supportive, professional, and consistently delivers on time.”',
    logoUrl: 'assets/images/Logos/Testimonials/DB-logo-1.jpg'
  },
  {
    id: 6,
    name: 'Rajesh AR',
    role: 'Chief Executive Officer',
    quote: '“Congratulations on 10 years! Wishing you growth, innovation, and customer focus values that will lead you to becoming a top global assessment partner.”',
    logoUrl: 'assets/images/Logos/Testimonials/LearnetLogo.webp'
  }
];

export const LANDING_FAQS: FaqItem[] = [
  {
    id: 1,
    question: 'What is Certiplate?',
    answer: 'Certiplate is a unified, intelligent assessment and certification system that replaces fragmented tools with an end-to-end platform for exam creation, delivery, AI proctoring, and real-time analytics.'
  },
  {
    id: 2,
    question: 'What are the key features of Certiplate?',
    answer: 'Certiplate provides AI proctoring with face and tab-switch detection, live video surveillance, volume bulk transactions, customizable certificate generation, automated grading, and real-time security alerts.'
  },
  {
    id: 3,
    question: 'Who can use Certiplate?',
    answer: 'Certiplate is built for universities, K-12 school systems, accreditation bodies, corporate L&D departments, government training programs, and competitive exam preparation centers.'
  },
  {
    id: 4,
    question: 'Is Certiplate secure?',
    answer: 'Yes, Certiplate uses multi-layered security protocols including identity verification, browser lockdown capabilities, encrypted candidate data streams, and automated AI cheat detection.'
  },
  {
    id: 5,
    question: 'Can organizations customize certificate designs?',
    answer: 'Yes, organizations can upload custom templates, add dynamic fields, watermarks, digital signatures, and QR verification badges tailored to their branding guidelines.'
  },
  {
    id: 6,
    question: 'Can Certiplate integrate with existing systems?',
    answer: 'Certiplate offers REST APIs and webhook integrations that connect seamlessly with existing Learning Management Systems (LMS), HR software, and candidate databases.'
  },
  {
    id: 7,
    question: 'Is there any limit to the number of certificates that can be issued?',
    answer: 'Certiplate’s cloud infrastructure is designed to auto-scale, supporting thousands of concurrent examinations and unlimited certificate issuance based on your subscription tier.'
  },
  {
    id: 8,
    question: 'How long does it take to issue certificates?',
    answer: 'Certificates can be generated and issued instantly upon exam submission or automated evaluation completion.'
  },
  {
    id: 9,
    question: 'Is Certiplate mobile-friendly?',
    answer: 'Yes, candidate assessment interfaces and verification portals are fully responsive and optimized across mobile, tablet, and desktop devices.'
  },
  {
    id: 10,
    question: 'What industries can use Certiplate?',
    answer: 'Certiplate serves higher education, IT & technology certifications, healthcare licensing, BFSI compliance training, vocational skill bodies, and competitive recruitment.'
  },
  {
    id: 11,
    question: 'Does Certiplate support multilingual certificates?',
    answer: 'Yes, Certiplate supports international character sets and localized template text for multi-region certificate issuance.'
  },
  {
    id: 12,
    question: 'What are the benefits of using Certiplate?',
    answer: 'Key benefits include reduced operational overhead, elimination of manual proctoring errors, high examination integrity, instant candidate reporting, and tamper-proof digital credentials.'
  },
  {
    id: 13,
    question: 'Is technical support available for Certiplate users?',
    answer: 'Yes, we offer 24/7 technical support, dedicated account assistance for enterprise clients, and comprehensive documentation.'
  },
  {
    id: 14,
    question: 'Can Certiplate support international certifications?',
    answer: 'Yes, Certiplate complies with global data privacy guidelines and supports international time zones and localization standards.'
  },
  {
    id: 15,
    question: 'Is proctoring available (relevant for paid mock tests)?',
    answer: 'Yes, both automated AI proctoring and human-in-the-loop live invigilation options are available for high-stakes exams and paid mock tests.'
  },
  {
    id: 16,
    question: 'How do the reporting and analytics features work?',
    answer: 'Certiplate provides real-time dashboards with candidate performance metrics, cheat detection timelines, cohort comparisons, and downloadable audit-ready PDF/CSV reports.'
  }
];

export const LANDING_PRICING_PLANS: PricingPlan[] = [
  {
    id: 'starter',
    name: 'Starter',
    amount: '50',
    perText: '/ Instance',
    description: 'For independent instructors & small teams getting started with online exams.',
    concurrentExams: 'Up to 100 concurrent exams',
    monthlyTotal: 'Up to 1000/ month total',
    ctaText: 'Get Started',
    includedFeatures: ['Basic Exam Engine', 'Automated Scoring', 'Email Support'],
    excludedFeatures: ['Anti-Cheating & AI Proctoring', 'Live Warning Generation', 'Bulk Transactions']
  },
  {
    id: 'standard',
    name: 'Standard',
    amount: '75',
    perText: '/ Instance',
    description: 'Perfect for schools and colleges looking for basic automated security for online exams.',
    concurrentExams: 'Up to 500 concurrent exams',
    monthlyTotal: 'Up to 5000/ month total',
    ctaText: 'Get Started',
    includedFeatures: [
      'Everything in Starter',
      'Identity Access Management (IAM)',
      'Volume Bulk Transactions',
      'Remote Invigilated & Live Chat',
      'Live Warning Generation',
      'Regular Image & Feedback Capture',
      'AI Face & Tab-Switch Detection'
    ],
    excludedFeatures: []
  },
  {
    id: 'business',
    name: 'Business',
    amount: '100',
    perText: '/ Instance',
    description: 'For professional training institutes and corporations requiring advanced, end-to-end security.',
    concurrentExams: 'Up to 1500 concurrent exams',
    monthlyTotal: 'Up to 15,000/ month total',
    ctaText: 'Get Started',
    includedFeatures: [
      'Everything in Standard',
      'Advanced Audio & Eye Tracking',
      'Custom LMS & API Integrations',
      'Priority 24/7 Support',
      'Real-Time Analytics Dashboard',
      'Advanced Cybersecurity Audits'
    ],
    excludedFeatures: []
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    amount: 'Custom',
    customRate: true,
    perText: '',
    description: 'Tailor-made solution for large administration requiring specialized setups.',
    concurrentExams: 'Unlimited concurrent exams',
    monthlyTotal: 'Unlimited total',
    ctaText: 'Contact Us',
    includedFeatures: [
      'Everything in Business',
      'Dedicated Account Manager',
      'On-Premise / Private Cloud Setup',
      'Custom SLA & Compliance SLA',
      'Custom Proctored Workflows'
    ],
    excludedFeatures: []
  }
];
